import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'circle-progress',
  imports: [],
  templateUrl: './circle-progress.html',
  styleUrl: './circle-progress.css'
})

export class CircleProgress implements OnInit {
  @Input() progress: number = 0;
  ngOnInit(): void {
    this.loadData();
  }
  loadData() {
    let scrollProgress = document.getElementById('progress');
    if (scrollProgress != null) {
      var turn = (100 - this.progress) / 100;
      if (turn < 0) {
        turn = 0;
      }
      scrollProgress.style.background = `conic-gradient(from ${turn}turn, #F3D157 ${this.progress}%, #f2f2f4 ${this.progress}%)`;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.loadData();
  }
}
